import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Lotus } from "@/components/Motifs";

const NAV = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/collections", label: "Collections" },
  { to: "/admin/folk-art", label: "Folk Art" },
  { to: "/admin/journal", label: "Journal" },
  { to: "/admin/enquiries", label: "Enquiries" },
  { to: "/admin/content", label: "Site Content" },
];

export default function AdminLayout() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("ipsita_token");
        navigate("/admin/login");
      })
      .finally(() => setChecking(false));
  }, [navigate]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("ipsita_token");
    navigate("/admin/login");
  };

  if (checking) {
    return (
      <main className="min-h-screen bg-bone flex items-center justify-center" data-testid="admin-loading">
        <p className="text-ink/50 font-light tracking-[0.2em] uppercase text-xs">Opening the studio…</p>
      </main>
    );
  }
  if (!user) return null;

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-bone flex flex-col md:flex-row">
      <aside className="md:w-60 bg-ink text-paper md:min-h-screen shrink-0 flex md:flex-col">
        <div className="p-6 flex md:flex-col w-full md:w-auto items-center md:items-start justify-between gap-6">
          <Link to="/admin" data-testid="admin-home-link" className="flex items-center gap-2.5">
            <Lotus className="w-6 h-6 text-alta" />
            <span className="font-serif text-xl tracking-[0.24em]">IPSITA</span>
          </Link>
          <nav className="flex md:flex-col gap-1 md:gap-2 md:mt-10 overflow-x-auto" aria-label="Admin">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-[10px] font-medium tracking-[0.2em] uppercase whitespace-nowrap transition-colors ${
                    isActive ? "text-alta bg-paper/5" : "text-paper/60 hover:text-paper"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="md:mt-auto p-6 flex md:flex-col gap-3 items-center md:items-start">
          <Link to="/" data-testid="admin-view-site-link" className="text-[10px] tracking-[0.2em] uppercase text-paper/50 hover:text-paper transition-colors">
            ← View Site
          </Link>
          <button onClick={logout} data-testid="admin-logout-button" className="text-[10px] tracking-[0.2em] uppercase text-paper/50 hover:text-alta transition-colors">
            Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 p-5 md:p-10 max-w-full overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
